import { setup, logSubscription } from './push-simple/app';

$("#sidebar1").ready(function () {
    setup(logSubscription);
});